//React
import React from 'react'
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//Action
import * as myProfileAction from '../action/myProfileAction';
import * as myProofAction from '../action/myProofAction';
import * as lightboxAction from '../action/lightboxAction';
import * as uiAction from '../action/uiAction';
import * as helpAction from '../action/helpAction';
//Add
import { imageResize, imageRotate } from '../func/imageResizeRotate';
import { scroller, Element } from 'react-scroll';
import { withAlert } from 'react-alert';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Fab from '@material-ui/core/Fab';
import Box from '@material-ui/core/Box';
//Icon
import AddIcon from '@material-ui/icons/Add';
import ClearIcon from '@material-ui/icons/Clear';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import LockIcon from '@material-ui/icons/Lock';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import SecurityIcon from '@material-ui/icons/Security';
import { FaIdCard } from 'react-icons/fa';


//image
import hnUnten from '../img/proof/hn-unten.jpg';
import hnHokensyou from '../img/proof/hn-hokensyou.jpg';
//import hnJyuminhyou from '../img/proof/hn-jyuukicard.jpg';
import hnPassport from '../img/proof/hn-passport.jpg';
import hnMynumber from '../img/proof/hn-mynumber.png';
import ssUnten from '../img/proof/ss-unten.jpg';
import ssSyain from '../img/proof/ss-syain.jpg';
import ssPassport from '../img/proof/ss-passport.jpg';
import snGensen from '../img/proof/sn-gensen.jpg';
import snKakutei from '../img/proof/sn-kakutei.jpg';
import snSyotoku from '../img/proof/sn-syotoku.jpg';
import dsDokushin from '../img/proof/ds-dokushin.jpg';
import dsKoseki from '../img/proof/ds-koseki.jpg';
import truste from '../img/truste/truste.png';
//Part
import PartDropZone from './PartDropZone';
import PartImageUploadHelp from './PartImageUploadHelp';
import PartPageTitle from './PartPageTitle';

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      proofType: null,
      uploadThumb: [null, null, null],
  	}

    if ((window.innerWidth * 0.7) > 240) {
      this.imgMaxSize = 240;
    }
    else {
      this.imgMaxSize = (window.innerWidth * 0.7);
    }
  }

  componentDidMount() {
    document.title = '証明書の申請 - パートナーズ';
    window.scrollTo(0, 0);
    if (this.props.match.params.type === 'person') {
      this.setState({proofType: 'person'});
      this.setState({proofTypeShort: 'hn'});
    }
    else if (this.props.match.params.type === 'photo') {
      if (this.props.my.photo.main.uri) {
        this.setState({proofType: 'photo'});
        this.setState({proofTypeShort: 'ss'});
      }
      else {
        this.setState({proofType: 'photoError'});
      }
    }
    else if (this.props.match.params.type === 'income') {
      this.setState({proofType: 'income'});
      this.setState({proofTypeShort: 'sn'});
    }
    else if (this.props.match.params.type === 'single') {
      this.setState({proofType: 'single'});
      this.setState({proofTypeShort: 'ds'});
    }
    else {
      this.props.history.push('/my/proof/');
    }
  };

  async _imageLoad(key, file) {
    let uploadThumb = this.state.uploadThumb;
    await imageResize(file, 1200).then((res) => {
      uploadThumb[key] = res.uri;
      this.setState({uploadThumb: uploadThumb});
    }).catch((err) => {
      uploadThumb[key] = null;
      this.setState({uploadThumb: uploadThumb});
      this.props.snackOpen('error', err.comment , 5000)
    })
  }

  async _imageRotate(index, rotate) {
    let uploadThumb = this.state.uploadThumb;
    let file = uploadThumb[index];
    await imageRotate(file, rotate).then((res) => {
      uploadThumb[index] = res.uri;
      this.setState({uploadThumb:uploadThumb});
    })
  }

  _submit() {
    let imageBase64Arr = this.state.uploadThumb.filter(v => v);
    this.props.myProofAddNext(this.state.proofType, imageBase64Arr, () => {
      if (this.state.proofType === 'person') {
        window.gtag("event", 'proofPerson_add');
      }
      this.props.history.push('/my/#myProofBox');
    });
  }

  _mailSubmit() {
    let mailto: string = "mailto:support@partner-s.net?subject=証明書の申請 [ID:"+this.props.auth.ui+"]&body=[type:"+this.state.proofType+"]%0d%0a%0d%0a 件名、本文は編集せずに画像ファイルを1枚添付して送信してください。%0d%0a%0d%0a iPhoneでの添付方法%0d%0aメールの本文を長押しします。「選択」、「全選択」、「ペースト」の隣に「矢印マーク」をタップし、「写真またはビデオを挿入」をタップして画像ファイルを選択してください。%0d%0a%0d%0aAndroidでの添付方法%0d%0aメールソフトにより異なりますが、メール作成画面のクリップマークをタップしていただき画像ファイルを選択してください。";
    window.location.href = mailto;
  }

  _scrollTruste() {
    scroller.scrollTo('truste_block', {
      delay: 300,
      duration: 300,
      smooth: true,
      offset: -50,
    })
  }

  _renderForm(value, index) {

    if (value) {
      return (
        <div key={index}>
            <div style={{textAlign:'center', margin:'5px', position:'relative', minHeight:'50px'}}>
              <div align='center' style={{padding:'5px', position:'relative'}}>
                <img style={{ width:this.imgMaxSize, height:this.imgMaxSize, objectFit:'contain' }} src={this.state.uploadThumb[index]} alt="" id='thumb' />
                <IconButton
                  style={{position:'absolute', right:'0px', top:'0px'}}
                  onClick={ () => {
                    let uploadThumb = this.state.uploadThumb;
                    uploadThumb.splice(index, 1);
                    uploadThumb.push(null);
                    this.setState({uploadThumb: uploadThumb});
                  }}
                >
                  <ClearIcon/>
                </IconButton>
              </div>
            </div>


          <div style={{textAlign:'center',}}>
            <Fab
              color='inherit'
              size='small'
              onClick={ () => this._imageRotate(index, 'l')}
            >
              <RotateLeftIcon/>
            </Fab>
            &nbsp;
            <Fab
              color='inherit'
              size='small'
              onClick={ () => this._imageRotate(index, 'r')}
            >
              <RotateRightIcon/>
            </Fab>
          </div>
        </div>
      )
    }
    else {

      let htmlfor =  "photo_file_" + index;

      if (index ===  0) {
        return (
          <div key={index}>
            <PartDropZone
              handleDrop={ (e) => this._imageLoad(e) }
              style={{position:'relative'}}
            >
              <div
                style={{
                  position:'absolute',
                  top:'-20px',
                  left:'10px',
                  background:'#FFF',
                  padding:'5px',
                  display:'flex',
                  alignItems:'center',
                  color:'#666',
                }}
              >
                <LockIcon /><span style={{fontSize:'0.9em'}}>証明書は暗号化され安全に送信されます</span>
              </div>
                <div>
                  <div align='center' style={{padding:'10px'}}>
                    <label htmlFor={htmlfor} style={{display:'block'}}>
                      <IconButton component="span">
                        <FaIdCard style={{fontSize:'4em'}}/>
                      </IconButton>
                    </label>

                    <label htmlFor={htmlfor} style={{cursor:"pointer", display:'block'}}>
                      <Button variant="contained" color='primary' component="span">
                        <div>
                          <span style={{fontSize:'1.2em'}}>ファイルを選択する</span>
                        </div>
                      </Button>
                    </label>
                  </div>
                </div>

                <input
                  type='file'
                  id={htmlfor}
                  accept='image/*'
                  onChange={ (e) => {
                    this._imageLoad(index, e.target.files[0]);
                    e.target.value = null;
                  }}
                  style={{opacity:'0'}}
                />
            </PartDropZone>
          </div>
        )
      }
      else if (this.state.uploadThumb[(index - 1)]) {
        return (
          <div key={index}>
            <div align='center' style={{padding:'10px'}}>
              <label htmlFor={htmlfor} style={{cursor:"pointer", display:'block'}}>
                <Button variant="outlined" color='primary' component="span">
                    <span style={{fontSize:'1.2em'}}>画像を追加する</span>
                    <AddIcon />
                </Button>
              </label>
              <input
                type='file'
                id={htmlfor}
                accept='image/*'
                onChange={ (e) => {
                  this._imageLoad(index, e.target.files[0]);
                  e.target.value = null;
                }}
                style={{opacity:'0'}}
              />
            </div>
          </div>
        )
      }

    }

  }


  render() {

    let proofTypeJa = null;
    let proofSample = [];
    let proofChecklist= [];
    let proofForm= false;
    let errorComment = null;
    if (this.state.proofType === 'person') {
      proofTypeJa = '本人証明';
      proofSample = [
        {uri:hnUnten, name:'運転免許証'},
        {uri:hnHokensyou, name:'保険証'},
        {uri:hnPassport, name:'パスポート'},
        {uri:hnMynumber, name:'マイナンバーカード'},
      ];
      proofChecklist = [
        'お名前', '生年月日', '有効期限', '発行元'
      ];
      proofForm = true;
    }
    else if (this.state.proofType === 'photo') {
      proofTypeJa = '写真証明';
      proofSample = [
        {uri:ssUnten, name:'運転免許証'},
        {uri:ssSyain, name:'社員証'},
        {uri:ssPassport, name:'パスポート'},
      ];
      proofChecklist = [
        '発行元', '写真', '有効期限', 'お名前'
      ];
      proofForm = true;
    }
    else if (this.state.proofType === 'income') {
      proofTypeJa = '収入証明';
      proofSample = [
        {uri:snGensen, name:'源泉徴収'},
        {uri:snKakutei, name:'確定申告書'},
        {uri:snSyotoku, name:'所得証明'},
      ];
      proofChecklist = [
        'お名前', '発行元', '収入と所得', '発行年月日', '税務署,会社の捺印(e-Taxは受付番号)'
      ];
      proofForm = true;
    }
    else if (this.state.proofType === 'single') {
      proofTypeJa = '独身証明';
      proofSample = [
        {uri:dsDokushin, name:'独身証明'},
        {uri:dsKoseki, name:'戸籍謄本'},
      ];
      proofChecklist = [
        'お名前', '身分事項の婚姻について', '発行元', '役所の印', '発行日(6ヶ月以内)'
      ];
      proofForm = true;
    }
    else if (this.state.proofType === 'photoError') {
      proofTypeJa = '写真証明';
      errorComment = (
        <div>
          <h3>
            写真証明は事前にメイン写真を<br/>掲載してから申請してください
          </h3>
          <div style={{margin:'10px'}}>
            <Button
              variant="outlined"
              color="primary"
              onClick={ () => this.props.history.push('/my/#photoBlock') }
            >
              メイン写真の掲載はコチラ
            </Button>
          </div>
        </div>
      );
      proofForm = false;
    }

    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <PartPageTitle
          title={proofTypeJa + 'の登録'}
          onback={ '/my/proof/' }
        />

        {
          (proofForm) ? (
            <div style={{margin:'10px 0px'}}>

              <h2 align='center'>
                <span className='i-b'>この証明書の中から</span>
                <span className='i-b'>１つ申請してください</span>
              </h2>

              <div align='center' style={{margin:'10px'}}>
                <div>
                  <div
                    style={{
                      display:'flex',
                      flexDirection:'row',
                      textAlign:'center',
                      alignItems:'center',
                      justifyContent:'center',
                      flexWrap: 'wrap',
                    }}
                  >
                    {
                      proofSample.map(
                        (value, index, arr) => {
                          return(
                            <div
                              key={index}
                              style={{maxWidth:'240px', minWidth:'85px', width:'30%', cursor:'pointer', margin:'3px',position:'relative', overflow:'hidden'}}
                              onClick={ () => this.props.lightboxOpen(arr.map( (value, index) => {return {src:arr[index].uri, comment:'[' + arr[index].name + '] 赤枠以外は伏せていただいても問題ございません'}} ), index) }
                              className='round12'
                            >
                              <img
                                src={value.uri}
                                style={{width:'100%', height:'auto'}}
                                alt=""
                              />
                              <div
                                style={{
                                  position:'absolute',
                                  top:0,
                                  left:0,
                                  height:"100%",
                                  width: "100%",
                                  display: 'flex',
                                  justifyContent:'center',
                                  alignItems:'center',
                                  backgroundColor:'rgba(0, 0, 0, 0.5)'
                                }}
                              >
                    						<div style={{color:'#FFFFFF', fontSize:'0.9em', fontWeight:'bold', textShadow:'0px 1px 5px #000'}}>{value.name}</div>
                    					</div>
                              <ZoomInIcon
                                style={{
                                  position: 'absolute',
                                  top:'1px',
                                  right:'1px',
                                  fontSize:'2em',
                                  color:'#FFFFFF',
                                }}
                              />

                            </div>
                          )
                        }
                      )
                    }
                  </div>
                  <div className='proof_info_baloon'>
                    {
                      proofChecklist.map(
                        (value, index, arr) => {
                          return(
                            <span
                              className='red_icon'
                              key={index}
                              style={{fontSize:'0.9em'}}
                            >
                              {value}
                            </span>
                          )
                        }
                      )
                    }

                    <div style={{color:'#666',fontSize:'0.9em'}}>
                      赤枠以外の情報は隠していただいて構いません
                    </div>

                  </div>
                </div>
              </div>

              <div align='center' style={{margin:'10px',paddingBottom:'20px'}}>
                <div style={{maxWidth:'400px',textAlign:'left'}}>
                  <div style={{borderRadius:'10px 10px 0px 0px',background:'#4376AB', padding:'10px'}}>
                    <div align='center'>
                      <div style={{color:'#FFF',textShadow:'1px 1px 1px rgba(0,0,0,0.2)'}}>
                        <SecurityIcon style={{verticalAlign:'middle'}}/>&nbsp;
                        <span style={{fontSize:'1.1em', verticalAlign:'middle'}}>個人情報を安全に守ります</span>
                      </div>

                    </div>
                  </div>
                  <div style={{borderRadius:'0px 0px 10px 10px',background:'#d4dfeb', padding:'5px'}}>
                    <ul style={{margin:'5px 5px 5px 25px',color:'#333'}}>
                      <li style={{fontSize:'0.9em'}}>
                        証明書データはサポートに送信され一切公開されません。
                      </li>
                      <li style={{fontSize:'0.9em'}}>
                        日本プライバシー認証機構が発行する
                        <span
                          onClick={ () => this._scrollTruste()}
                          className='link'
                          style={{color:'red'}}
                        >
                          <u>TRUSTeマーク</u>
                        </span>
                        を取得しています。
                      </li>
                    </ul>

                  </div>
                </div>
              </div>


              <Box boxShadow={2} style={{background:'#FFF',padding:'10px'}}>


                <h2 align='center'>証明書の画像をアップロード</h2>
                <div style={{margin:'20px 15px'}}>

                    <div>
                      {
                        this.state.uploadThumb.map(
                          (value, index) => this._renderForm(value, index)
                        )
                      }

                      <div align='center' style={{padding:'10px'}}>
                        <Button
                          variant="contained"
                          color="secondary"
                          style={{minWidth:'200px'}}
                          onClick={ () => this._submit() }
                          disabled={ this.state.uploadThumb[0] ? false: true }
                          startIcon={<CloudUploadIcon />}
                        >
                          <span style={{fontSize:'1.4em'}}>アップロード</span>
                        </Button>
                      </div>

                      <div style={{padding:'5px'}} align='right'>
                        <PartImageUploadHelp />
                      </div>
                    </div>

                  </div>
              </Box>

              <div style={{margin:'15px', color:'#666'}}>
                <h3 align='center'>証明書の送信でお困りの場合</h3>
                <u className='link' onClick={ () => this._mailSubmit() }>メールで送信する</u>
                をクリックしてメールソフトが起動したら証明書の画像を添付して送信してください。
              </div>


              <Element name='truste_block'>
                <h3 align='center'>TRUSTe認証を取得しています</h3>
                <div align='center'>
                  <img
                    src={ truste }
                    alt=''
                  />
                </div>
                <div  style={{padding:'10px'}}>
                  「TRUSTe」マークは 日本プライバシー認証機構が 厳正な審査のもと付与されます。 <br />
                  「パートナーズ」は、個人情報保護法よりも 高い基準で個人情報の利用や保護を 実施していることを意味します。
                </div>
              </Element>
            </div>
          ): (
            <div align='center' style={{margin:'10px'}}>
              {
                errorComment
              }
            </div>
          )
        }


      </div>

    )

  }
}


const mapStateToProps = (state) => {
	return {
    auth: state.auth,
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...myProofAction,
    ...lightboxAction,
    ...uiAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withAlert()(Comp));
